import { api } from './client';

export type MesaEstado = 'libre' | 'reservada' | 'ocupada' | 'en_grupo';

export interface Mesa {
  id: number;
  sede_id: number;
  nombre: string;
  capacidad: number;
  activa: boolean;
  notas: string | null;
  created_at: string;
  estado: MesaEstado;
  pedido_id: number | null;
  pedido_estado: string | null;
  pedido_total: number | null;
  pedido_inicio: string | null;
  pedido_referencia: string | null;
  grupo_id: number | null;
  grupo_nombre: string | null;
  proxima_reserva: string | null;
  proxima_reserva_id: number | null;
  proxima_reserva_cliente: string | null;
  proxima_reserva_personas: number | null;
  // Plano guardado en el servidor (mig. 065). NULL = el servidor todavía no
  // conoce la posición de esta mesa y se usa la copia del navegador.
  pos_x: number | null;
  pos_y: number | null;
  forma: 'round' | 'square' | 'rect' | 'rectv' | null;
  zona: 'salon' | 'terraza' | 'barra' | null;
}

export interface PlanoMesa {
  id: number;
  x: number;
  y: number;
  shape: 'round' | 'square' | 'rect' | 'rectv';
  zona: 'salon' | 'terraza' | 'barra' | null;
}

export const listMesas = (sede_id: number) =>
  api.get<Mesa[]>(`/api/mesas?sede_id=${sede_id}`);

export const crearMesa = (data: { sede_id: number; nombre: string; capacidad?: number; notas?: string }) =>
  api.post<Mesa>('/api/mesas', data);

export const editarMesa = (id: number, data: Partial<{ nombre: string; capacidad: number; notas: string; activa: boolean }>) =>
  api.patch<Mesa>(`/api/mesas/${id}`, data);

export const eliminarMesa = (id: number) =>
  api.del<{ ok: boolean; soft?: boolean }>(`/api/mesas/${id}`);

export const unirMesas = (sede_id: number, mesa_ids: number[], nombre?: string) =>
  api.post<{ id: number; nombre: string; mesa_ids: number[] }>('/api/mesas/grupos', { sede_id, mesa_ids, nombre });

// Guarda el plano COMPLETO de la sede (mig. 065). Ver PUT /api/mesas/layout.
export const guardarPlanoMesas = (sede_id: number, mesas: PlanoMesa[]) =>
  api.put<{ ok: boolean; actualizadas: number; ignoradas: number[] }>('/api/mesas/layout', { sede_id, mesas });

// Zoom del plano por sede (mig. 066): escala de las mesas dentro del plano.
export const getPlanoMesas = (sede_id: number) =>
  api.get<{ sede_id: number; zoom: number }>(`/api/mesas/plano?sede_id=${sede_id}`);

export const guardarZoomPlano = (sede_id: number, zoom: number) =>
  api.put<{ ok: boolean; sede_id: number; zoom: number }>('/api/mesas/plano', { sede_id, zoom });

export const separarGrupo = (grupo_id: number) =>
  api.del<{ ok: boolean }>(`/api/mesas/grupos/${grupo_id}`);
